module.exports = __webpack_public_path__ + "static/media/5.0d8458fd.jpeg";